import { save } from "plano_engine";
const EXIT_BEHAVIOR = {
    save: 1,
    cancel: 2,
    cancelAndExit: 3
};
export default {
    data: () => ({
        checkSavedOnExit: true,
        showExitModal: false,
        initialPlano: undefined,
        readOnly: undefined // Boolean to determine if the opened plano is editable or  not.
    }),
    async beforeRouteLeave(to, from, next) {
        let canLeave = await this.exitPlanoBuilder();
        next(canLeave);
    },
    methods: {
        async exitPlanoBuilder() {
            if (this.checkSavedOnExit && !this.isSaved()) {
                this.showExitModal = true;
                const exitBehavior = await new Promise(resolve => (this.exitResolver = resolve));
                this.exitResolver = undefined;
                this.showExitModal = false;
                if (exitBehavior === EXIT_BEHAVIOR.save) {
                    if (this.readOnly) {
                        this.toggleModalSaveAs(true);
                        return false;
                    } else {
                        await this.save();
                    }
                }
                return exitBehavior !== EXIT_BEHAVIOR.cancel;
            }
        },
        closeExitModal() {
            this.exitResolver(EXIT_BEHAVIOR.cancel);
        },
        saveAfterExit(shouldSave) {
            this.exitResolver(shouldSave ? EXIT_BEHAVIOR.save : EXIT_BEHAVIOR.cancelAndExit);
        },
        isSaved() {
            const context = save();
            return JSON.stringify(this.initialPlano) === JSON.stringify(context);
        },
        beforeUnloadFunc(event) {
            if (this.checkSavedOnExit && !this.isSaved()) {
                event.returnValue = "";
            }
        }
    },
    created() {
        window.addEventListener("beforeunload", this.beforeUnloadFunc);
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeUnloadFunc);
    }
};



// WEBPACK FOOTER //
// ./src/mixins/ExitPlanoBuilderMixin.js